module.exports = __webpack_public_path__ + "img/google.3fc3bdfb.svg";